export default "__VITE_ASSET__C2R72vbz__ 1920w";